import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { DbTableDefinition } from 'src/app/_services/persistence/db-persistence/db-table-definition';

@Injectable({
  providedIn: 'root',
})
export class RemoteActionDbTableDefinition extends DbTableDefinition {
  tableName = 'remote_actions';
  tableStructure = `(id INTEGER PRIMARY KEY,
       endpoint VARCHAR(100) NOT NULL,
       data TEXT,
       cachable BOOLEAN,
       fifo BOOLEAN,
       authenticationRequired BOOLEAN,
       rawRequestTimestamp LONG,
       editedRequestTimestamp LONG,
       executionTimestamp LONG,
       shortLabel TEXT,
       shortLabelTranslate BOOLEAN,
       longLabel TEXT,
       longLabelTranslate BOOLEAN
      );`;

  constructor() {
    super();
    // Add UpdateStatements to Map
    if (Capacitor.getPlatform() === 'web') {
      this.alterStatements.push({
        table: this.tableName,
        col: 'afterSendAction',
        type: 'TEXT',
      });
      this.alterStatements.push({
        table: this.tableName,
        col: 'hideInDayProtocol',
        type: 'BOOLEAN',
      });
      this.alterStatements.push({
        table: this.tableName,
        col: 'pi_delayFilesDeletion',
        type: 'BOOLEAN',
      });
      this.alterStatements.push({
        table: this.tableName,
        col: 'filePath',
        type: 'TEXT',
      });
    } else {
      this.updateStatements.set(11, [
        `ALTER TABLE ${this.tableName} ADD COLUMN afterSendAction TEXT;`,
      ]);

      this.updateStatements.set(12, [
        `ALTER TABLE ${this.tableName} ADD COLUMN hideInDayProtocol BOOLEAN;`,
      ]);

      this.updateStatements.set(15, [
        `ALTER TABLE ${this.tableName} ADD COLUMN pi_delayFilesDeletion BOOLEAN;`,
      ]);

      this.updateStatements.set(25, [
        `ALTER TABLE ${this.tableName} ADD COLUMN filePath Text;`,
      ]);
    }
  }
}
